import * as actionTypes from '../actionTypes/success';
export function getPowers(productId, powerType) {
    return { type: actionTypes.POWERS_DETAIL_LOAD, productId, powerType};
    }
export function getSavedPrescription(powerType) {
    return { type: actionTypes.SAVED_PRESCRIPTION_LOAD, powerType};
}
export function submitPowers(itemid, data, userEmail, orderId) {
    return { type: actionTypes.SUBMIT_POWERS_LOAD, itemid, data, userEmail, orderId};
}
export function getSubmittedPowers(itemid, userEmail) {
    return { type: actionTypes.SUBMITTED_POWERS_LOAD, itemid, userEmail};
}
export function getSubmittedOtp(otp, email) {
    return { type: actionTypes.OTP_SUBMISSION_LOAD, otp, email};
}
export function enterErrorFunc(data) {
    return { type: actionTypes.MSG_ERROR, data };
}
export function enterDataFunc(data) {
    return { type: actionTypes.ENTER_DATA, data };
}

export function activeFrameData(data, index) {
    return {type: actionTypes.ACTIVE_FRAME_DATA, data, index};
}
export function showPowerDD(data) {
    return { type: actionTypes.SHOW_DD, data };
}
export function updatePackages(itemid, data, orderId) {
    return { type: actionTypes.SUBMIT_PACKAGE_LOAD, itemid, data, orderId};
}
